<template>
	<div class="vx-row p-4">
		<div class="vx-col w-full" :class="showRouteMap ? 'md:w-1/2' : 'md:w-1/1'">
			<vx-card :title="null" class="mt-7" :cardBorder="true" :noShadow="true">
				<span class="g-subtitle" v-text="$t('Schedule.ListofEventsDay')"></span>
				<template slot="actions">
					<feather-icon
						v-show="!showRouteMap"
						icon="MapIcon"
						svgClasses="w-6 h-6"
						:title="btnMapTitle"
						@click="showRouteMap = !showRouteMap"
					></feather-icon>
				</template>
				<p class="g-label pt-4">
					{{ $t("Schedule.SelectDateToSeeEvents.Text1") }}
					<code>{{ $t("Schedule.SelectDateToSeeEvents.Text2") }}</code>
					{{ $t("Schedule.SelectDateToSeeEvents.Text3") }}
				</p>
				<div class="vx-row">
					<div class="vx-col lg:w-1/3 w-full">
						<datepicker
							name="start-date"
							class="w-full"
							v-model="currentDay"
							:language="$vs.rtl ? langHe : langEn"
						></datepicker>
					</div>
					<div class="vx-col lg:w-2/3 w-full flex">
						<vs-button
							v-show="!optimizationStatus && dataEvents.length > 0"
							class="ml-1 mr-1"
							icon-pack="feather"
							icon="icon-globe"
							@click.prevent="handleClickOptimizeRoute"
							>{{ optimizeRouteTittle }}
						</vs-button>
						<vs-button
							color="success"
							icon-pack="feather"
							icon="icon-save"
							class="ml-1 mr-1"
							v-show="optimizationStatus"
							@click.prevent="openConfirmAcceptOptimization"
							>{{ $t("Accept") }} {{ $t("Routing.Optimization") }}
						</vs-button>
						<vx-tooltip
							class="cursor-pointer"
							color="primary"
							position="top"
							:title="null"
							:text="$t('Schedule.Refresh')"
						>
							<vs-button
								class="ml-2"
								type="filled"
								icon-pack="feather"
								icon="icon-refresh-cw"
								@click.prevent="handleBtnRefresh"
							></vs-button>
						</vx-tooltip>
						<vx-tooltip
							v-show="dataEvents.length > 0 && !optimizationStatus"
							class="cursor-pointer"
							color="primary"
							position="top"
							:title="null"
							:text="$t('ExportAll')"
						>
							<vs-button
								class="ml-2"
								type="filled"
								icon-pack="feather"
								icon="icon-download"
								@click.prevent="showExportPopup"
							></vs-button>
						</vx-tooltip>
					</div>
				</div>
				<vs-alert
					class="mt-base"
					:color="optimizeAlert.color"
					:title="optimizeAlert.title"
					:active.sync="optimizeAlert.active"
					closable
					icon-pack="feather"
					close-icon="icon-x"
				>
					<span>{{ optimizeAlert.text }}</span>
				</vs-alert>
				<vs-alert
					class="mt-base"
					:active.sync="optimizeAlert2"
					closable
					icon-pack="feather"
					close-icon="icon-x"
					color="success"
					:title="$t('Routing.Optimization')"
				>
					{{ $t("Routing.SuccessOptimization.TextOne") }}
					<span
						class="text-inherit underline font-bold"
						style="cursor: pointer"
						@click="openConfirmAcceptOptimization"
					>
						{{ $t("Routing.SuccessOptimization.TextTwo") | capitalize }}
					</span>
					{{ $t("Routing.SuccessOptimization.TextThree") }}
					<span
						class="text-inherit underline font-bold"
						style="cursor: pointer"
						@click="openConfirmAcceptOptimization"
					>
						<feather-icon class="cursor-pointer" icon="SaveIcon" svgClasses="h-4 w-4" /> {{ $t("Accept") }}
						{{ $t("Routing.Optimization") }},
					</span>
					{{ $t("Routing.SuccessOptimization.TextFour") }}
				</vs-alert>
				<VuePerfectScrollbar class="scroll-area mt-1" v-once :settings="settings">
					<calendar-events-per-day
						ref="CalendarEventsPerDay"
						:handleSelected="handleSelected"
						:deletePoint="deletePoint"
						:currentDate="currentDate"
					/>
				</VuePerfectScrollbar>
			</vx-card>
		</div>
		<transition name="slide-fade">
			<div class="vx-col w-full md:w-1/2 pl-4" v-show="showRouteMap">
				<vx-card :title="null" :cardBorder="true" :noShadow="true">
					<div class="flex items-center justify-between items-center mb-4">
						<span class="g-subtitle" v-text="$t('Schedule.EventsOnTheMap')"></span>
						<feather-icon
							class="g-label--normal"
							icon="XIcon"
							svgClasses="w-6 h-6"
							:title="btnMapTitle"
							@click="showRouteMap = !showRouteMap"
						></feather-icon>
					</div>
					<div class="flex items-center justify-end items-center mb-4">
						<vs-button
							:title="btnAddPointTitle"
							color="primary"
							icon-pack="feather"
							icon="icon-map-pin"
							@click="activePopup = true"
							v-show="locationPointsLength < 2"
							class="mr-1 mt-4"
						>
							{{ btnAddPointTitle | capitalize }}
						</vs-button>
					</div>
					<div class="map-custom-container mt-6">
						<here-map
							name="theMap"
							latitude="4.671469"
							longitude="-74.073240"
							zoom="13"
							:width="widthMap"
							height="95vh"
							theme="uber"
							calledFrom="calendar"
						></here-map>
					</div>
				</vx-card>
			</div>
		</transition>
		<magic-wand v-if="showMagicWand"></magic-wand>
		<vs-popup :active.sync="activePopup" :title="btnAddPointTitle">
			<div class="mb-base">
				<p>{{ $t("Routing.DeparturePointOptionsTex") }}</p>
				<div class="flex items-center justify-center mt-4">
					<vs-avatar
						v-for="option in options"
						:key="option.id"
						:color="option.color"
						size="70px"
						icon-pack="feather"
						:icon="option.icon"
						@click="selectOrigin(option.id)"
						@mouseover="handleHover(option)"
					/>
				</div>
				<vs-alert
					:title="originPoint"
					:active="activeAlert"
					:color="originColor"
					vs-icon="new_releases"
					class="mt-4"
				>
					{{ vsAlertText }}
				</vs-alert>
			</div>
		</vs-popup>
		<vs-prompt
			@cancel="cancel"
			:cancel-text="$t('Cancel')"
			:accept-text="$t('Accept')"
			@accept="addPoint"
			@close="close"
			:is-valid="disableAcceptBtn"
			:active.sync="activePrompt"
			:title="btnAddPointTitle"
		>
			<div class="">
				<div>
					<small class="date-label">{{ $t("Type") }}</small>
					<div class="mb-2">
						<vs-radio
							:disabled="disableRadioStart"
							v-if="!disableRadioStart"
							v-model="typePoint"
							vs-value="start"
							class="mr-4"
							>{{ this.$t("Routing.DeparturePoint") }}
						</vs-radio>
						<vs-radio
							:disabled="disableRadioFinal"
							v-if="!disableRadioFinal"
							v-model="typePoint"
							vs-value="final"
							class="mr-4"
							>{{ this.$t("Routing.FinalPoint") }}
						</vs-radio>
					</div>
				</div>
				<small class="date-label">{{ $t("Name") }}</small>
				<vs-input v-model="formatData.activity_name" class="mb-2 w-full" />
				<vs-button
					:title="btnAddPointTitle"
					v-if="selectedOrigin === 'visitpoint'"
					color="primary"
					type="border"
					icon-pack="feather"
					icon="icon-search"
					@click="visitPointMounted = true"
					class="mt-2 w-full"
				>
					{{ searchVisitPoint | capitalize }}
				</vs-button>
				<div v-if="selectedOrigin === 'map'">
					<small class="date-label">{{ $t("Address") }}</small>
					<vs-input :placeholder="$t('Address')" v-model="formatData.address" class="w-full" />
				</div>
				<form-geo
					v-if="selectedOrigin === 'geo'"
					ref="FormGeo"
					:autoAddMarker="false"
					:setDataGeo="setDataGeo"
					:getDataGeo="true"
					:showDataGeoAlert="showDataGeoAlert"
				></form-geo>
				<vs-alert
					:active.sync="geoAlert"
					:color="geoAlertColor"
					vs-icon="new_releases"
					class="mt-2"
					closable
					icon-pack="feather"
					close-icon="icon-x"
				>
					{{ geoAlertText }}
				</vs-alert>
			</div>
		</vs-prompt>
		<!-- VISIT POINT LIST COMPONENT -->
		<vs-popup
			:fullscreen="true"
			:title="$t('ListVisitPoint')"
			:active.sync="visitPointMounted"
			class="vs-popup--content-custom"
		>
			<VisitPointFilterList :multiple="false" :handleAssigned="handleAssigned" v-if="visitPointMounted" />
		</vs-popup>
		<vs-prompt
			:title="optimizeRouteTittle"
			class="export-options"
			@accept="optimizeRoute"
			:accept-text="$t('Resource.Continue')"
			:cancel-text="$t('Cancel')"
			:active.sync="activeInitHourPrompt"
			:is-valid="initHour"
		>
			<div>
				<p class="mb-4">{{ $t("Routing.ConfigureInitHour") }}</p>
				<small class="date-label">{{ $t("InitHour") }}</small>
				<flat-pickr
					:config="configdateTimePicker"
					class="w-full"
					v-model="initHour"
					:placeholder="$t('Alarm.SelectInitTime')"
					name="dataHourInit"
				/>
				<span class="text-danger text-sm" v-show="errors.has('dataHourInit')">{{
					$t("Alarm.ValidInitHour")
				}}</span>
			</div>
		</vs-prompt>
		<!-- MAP COMPONENT -->
		<vs-popup
			:fullscreen="false"
			:title="vsPopupTitle"
			:active.sync="popupMapMounted"
			class="vs-popup--content-custom"
		>
			<p class="mb-2">{{ $t("Routing.FromMapTitle") }}</p>
			<popup-map
				v-if="popupMapMounted"
				:name="mapConfig.name"
				:latitude="mapConfig.latitude"
				:longitude="mapConfig.longitude"
				:zoom="mapConfig.zoom"
				:theme="mapConfig.theme"
				calledFrom="mapConfig.calledFrom"
				:getCallbackClick="callbackClick"
				:changeCursorEnable="true"
			></popup-map>
		</vs-popup>
	</div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
// Custom components
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import DateUtils from "@/helpers/DateUtils.js";
// Import Store Module
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
// Import Static filess
import eventAgendado from "@/assets/images/markers/event-agendado.png";
import eventReprogramado from "@/assets/images/markers/event-reprogramado.png";
import eventFinalizado from "@/assets/images/markers/event-finalizado.png";
import eventCancelado from "@/assets/images/markers/event-cancelado.png";
import eventEnProceso from "@/assets/images/markers/event-en_proceso.png";
import ease, {
	addDomMarker,
	addInfoBubble,
	addMarkerHereMap,
	calculateHereRoute,
	centerHereMap,
	clearMap,
	fitBoundsMarkerGroup,
	removeMarker,
	removeRoute,
	selectTool,
} from "../../utils/HereMap";
import HereMap from "../Maps/Maps";
import MagicWand from "./MagicWand";
import FormGeo from "@/components/zonification/FormGeo";
import VisitPointFilterList from "@/components/visit-point/list/VisitPointFilterList";
import PopupMap from "./PopupMap";
import CalendarEventsPerDay from "./CalendarEventsPerDay";

export default {
	name: "CalendarAddEvent",
	data() {
		return {
			msj: "helo",
			settings: {
				maxScrollbarLength: 60,
			},
			currentDay: new Date(),
			langHe: es,
			langEn: en,
			markerArray: [],
			possitionArray: [],
			showRouteMap: true,
			optimizeAlert2: false,
			geoAlert: false,
			geoAlertText: "",
			geoAlertColor: null,
			optimizationStatus: false,
			optimizeAlert: {
				active: false,
				text: "",
				title: "",
				color: "success",
			},
			formatData: {
				activity_name: "",
				visit_point_name: "",
				address: "",
				city: "",
				cx: 0,
				cy: 0,
				point: "",
				event_status_id: 0,
				id: 0,
			},
			positionArray: [],
			activePrompt: false,
			validName: true,
			activeAlert: false,
			activePopup: false,
			vsAlertText: "",
			selectToolSelected: false,
			originPoint: null,
			originColor: null,
			options: [
				{
					id: "map",
					name: this.$t("Map"),
					description: this.$t("Routing.FromMap"),
					icon: "icon-map",
					color: "success",
				},
				{
					id: "visitpoint",
					name: this.$t("VisitPoint"),
					description: this.$t("Routing.FromVisitPoint"),
					icon: "icon-map-pin",
					color: "danger",
				},
				{
					id: "geo",
					name: this.$t("MapModule.Georeferencer"),
					description: this.$t("MapModule.GeoSub"),
					icon: "icon-globe",
					color: "secondary",
				},
			],
			selectedOrigin: null,
			locationPoints: [],
			typePoint: "start",
			visitPointMounted: false,
			directionResponse: null,
			routeWaypointOrder: [],
			optimizeWaypoints: false,
			showMagicWand: false,
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
			},
			initHour: null,
			activeInitHourPrompt: false,
			popupMapMounted: false,
			mapConfig: {
				name: "popup-map",
				latitude: 0,
				longitude: 0,
				zoom: "13",
				theme: "uber",
				calledFrom: "CalendarAddEvent",
			},
		};
	},
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		widthMap() {
			let widthValue = "";
			if (this.$store.state.reduceButton && this.windowWidth > 600) {
				widthValue = "39vw";
			} else if (this.windowWidth > 600) {
				widthValue = "32.5vw";
			} else if (this.windowWidth < 600) {
				widthValue = "100%";
			}
			return widthValue;
		},
		dataEvents() {
			return this.$store.state.moduleSchedule.events;
		},
		currentResourceId() {
			return !this.$store.state.moduleSchedule ? 0 : this.$store.state.moduleSchedule.currentResourceId;
		},
		btnMapTitle() {
			return this.showRouteMap
				? `${this.$t("Routing.Title.Close")} ${this.$t("Map")}`
				: this.$t("MapModule.SeeDayScheduledRoute");
		},
		btnAddPointTitle() {
			return `${this.$t("Add")} ${this.$t("Routing.Point")}`;
		},
		vsPopupTitle() {
			return !this.locationPoints.some((l) => l.point === "start") && this.locationPointsLength === 0
				? this.$t("Routing.DeparturePoint")
				: this.$t("Routing.FinalPoint");
		},
		disableRadioStart() {
			return this.locationPoints.some((l) => l.point === "start");
		},
		disableRadioFinal() {
			return this.locationPoints.some((l) => l.point === "final");
		},
		locationPointsLength() {
			return this.locationPoints.length;
		},
		disableAcceptBtn() {
			const opts = {
				visitpoint: this.formatData.cx && this.formatData.cy ? true : false,
				map: this.formatData.cx && this.formatData.cy ? true : false,
				geo: this.geoAlertColor === "success" ? true : false,
			};
			return this.selectedOrigin ? opts[this.selectedOrigin] : false;
		},
		searchVisitPoint() {
			return `${this.$t("Search")} ${this.$t("VisitPoint")}`;
		},
		getCurrentVisitPoint() {
			return this.$store.getters["moduleVisitPoint/getCurrentVisitPoint"];
		},
		getCurrentResource() {
			const currentResource = this.$store.getters["moduleSchedule/getCurrentResource"];
			if (currentResource) {
				return currentResource;
			} else {
				return null;
			}
		},
		optimizeRouteTittle() {
			return `${this.$t("Routing.Buttons.Optimize")} ${this.$t("MapModule.Route")}`;
		},
		validateOptimizationPermission() {
			return this.checkServirouteConfig && this.servirouteCreatePermission;
		},
		servirouteCreatePermission() {
			return this.$store.getters.checkPermission("SERVIROUTES_C");
		},
		checkServirouteConfig() {
			const serviformConfig = this.$store.getters["moduleCompanyConfig/servirouteConfig"];
			if (serviformConfig && serviformConfig.config_json) {
				const {token} = serviformConfig.config_json;
				if (token) return true;
			}
			return false;
		},
		currentDate() {
			return DateUtils.toDefaultDateTime(this.currentDay, "YYYY-MM-DD");
		},
	},
	components: {
		CalendarEventsPerDay,
		VisitPointFilterList,
		PopupMap,
		FormGeo,
		MagicWand,
		HereMap,
		VuePerfectScrollbar,
		Datepicker,
		flatPickr,
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getEvents() {
			this.openLoading();
			removeRoute();
			this.positionArray = [];
			const payload = {
				init_date: DateUtils.toDefaultDateTime(this.currentDay, "YYYY-MM-DD"),
				end_date: DateUtils.toDefaultDateTime(this.currentDay, "YYYY-MM-DD"),
				resource_id: this.currentResourceId,
			};
			this.$store
				.dispatch("moduleSchedule/fetchEventsByResourceId", payload)
				.then((res) => {
					if (res.data.records !== null && res.data.records.length > 0) {
						this.$store.commit("moduleSchedule/SET_SCHEDULE_EVENTS_PER_DAYS", []);
						this.optimizeRouteWithHereRoute();
					} else {
						clearMap();
					}
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		/**
		 * https://mapicons.mapsmarker.com/markers/media/calendar/?custom_color=006fff
		 * @param statusId numero del estado del evento
		 */
		generateMarkerIconEvent(statusId) {
			const markerIcon = {
				1: "NOT_ASSIGNED",
				2: eventAgendado,
				3: eventReprogramado,
				4: "DELAYED",
				5: "ON_THE_WAY",
				6: eventEnProceso,
				7: eventFinalizado,
				8: eventCancelado,
			};
			return markerIcon[statusId] || eventReprogramado;
		},
		generateInfowindowContent(infoWindowData) {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.setAttribute("id", "infoWindow");
			$infowindowDivContent.style.cssText = "text-align: center";
			let $title = document.createElement("h4");
			$title.textContent = `Start at ${infoWindowData.init_hour}`;
			let $name = document.createElement("p");
			let $visitPoint = document.createElement("p");
			let $address = document.createElement("p");
			$name.textContent = `${infoWindowData.activity_name}`;
			$visitPoint.textContent = `${infoWindowData.visit_point_name}`;
			$address.textContent = `${infoWindowData.address}`;
			$docFragment.appendChild($title);
			$docFragment.appendChild($name);
			$docFragment.appendChild($visitPoint);
			$docFragment.appendChild($address);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
		addMarker(lat, lng, infoWindowData) {
			let icon = "";
			if (infoWindowData.event_status_id === 0) {
				icon =
					infoWindowData.point === "start"
						? require("@/assets/images/markers/white-flag.png")
						: require("@/assets/images/markers/finish-flag.png");
			} else {
				icon = this.generateMarkerIconEvent(infoWindowData.event_status_id);
			}
			// Opciones
			let options = {
				drag: false,
				icon,
				title: infoWindowData.activity_name || this.$t("MapModule.CurrentPosition"),
				info: infoWindowData,
				label: {
					text: " " + (infoWindowData.index ? infoWindowData.index : " "),
					color: "#FFFFFF",
					fontSize: "11px",
					fontWeight: "bold",
					className: "con-vs-chip mt-base p-1 vs-chip-primary con-color",
				},
				infoWindow: {
					content: this.generateInfowindowContent(infoWindowData),
				},
				infoLatLng: {lat, lng},
			};
			let newMarker = addMarkerHereMap(lat, lng, options, infoWindowData.event_status_id === 0 ? true : false);
			addInfoBubble(newMarker, options.infoWindow.content);
			this.positionArray.push({lat, lng});
			this.markerArray.push(newMarker);
			//add sequence
			addDomMarker({lat, lng}, infoWindowData.index ? infoWindowData.index : " ");
		},
		handleBtnRefresh() {
			this.clearData();
			this.markerArray = [];
			this.locationPoints = [];
			this.typePoint = "start";
			clearMap();
			this.getEvents();
			this.optimizeAlert.active = false;
			this.optimizeAlert2 = false;
		},
		clearData() {
			this.formatData = {
				activity_name: "",
				visit_point_name: "",
				address: "",
				city: "",
				cx: 0,
				cy: 0,
				point: "",
				event_status_id: 0,
				id: 0,
			};
			this.optimizationStatus = false;
			this.geoAlert = false;
			this.geoAlertText = "";
			this.geoAlertColor = null;
		},
		showExportPopup() {
			this.$refs.CalendarEventsPerDay.showActivePrompt();
		},
		/**
		 * TODO: Controlar el flujo de optimizacion de la ruta
		 */
		handleClickOptimizeRoute() {
			const defaultPoint = this.getDefaultPoint();
			if (!this.validateOptimizationPermission) {
				this.manageOptimizationAlert("ALERT");
				return;
			}
			if (Object.keys(defaultPoint).length > 0 && this.locationPoints.length === 0) {
				// Crear y agregar el punto por defecto al mapa y a la optimizacion
				this.setDataGeo(defaultPoint);
				this.addPoint();
				this.activeInitHourPrompt = true;
			} else if (Object.keys(defaultPoint).length <= 0 && this.locationPoints.length === 0) {
				this.openConfirmOptimize();
			} else {
				this.activeInitHourPrompt = true;
			}
		},
		openConfirmAcceptOptimization() {
			this.$vs.dialog({
				type: "confirm",
				color: "primary",
				title: `${this.$t("Accept")} ${this.$t("Routing.Optimization")}`,
				text: this.$t("Routing.AcceptOptimization"),
				accept: this.acceptOptimization,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		/**
		 * TODO: Optimizar la ruta
		 */
		optimizeRouteWithHereRoute() {
			this.optimizeWaypoints = false;
			this.markerArray = [];
			this.positionArray = [];
			removeRoute();
			clearMap();
			// agregamos markers
			this.dataEvents.forEach((element, index) => {
				this.addMarker(element.cy, element.cx, {...element, index: index + 1});
			});
			// Zoom sobre los markers
			fitBoundsMarkerGroup(this.markerArray);
			// Agregamos la ruta programada sobre el mapa
			calculateHereRoute(this.positionArray, {
				strokeColor: "#32BA7C",
				strokeOpacity: 1.0,
				lineWidth: 4,
				optimizeWaypoints: this.optimizeWaypoints,
				id: "RP",
			});
		},
		/**
		 * TODO: Recuperar el punto de partida por defecto del recurso
		 * ! El recurso debe tener una propiedad adicional de tipo location con el formato String '6.182280, -75.598677'
		 */
		getDefaultPoint() {
			let defaultPoint = {};
			// Buscar propiedad location en la  data del recurso
			const found = this.getCurrentResource.category_json_properties.find(
				(property) => property.type === "location"
			);
			if (found) {
				// Validar si la propiedad existe esta en la informacion adicional
				const locationPropertyName = found.name;
				if (Object.hasOwnProperty.call(this.getCurrentResource.additional_info, locationPropertyName)) {
					const location = this.getCurrentResource.additional_info[locationPropertyName]; // 6.182280, -75.598677
					if (!location) return defaultPoint;
					const [cy, cx] = location.split(",").map(Number); // [ 6.182280 , -75.598677]
					if (cy && cx) {
						defaultPoint = {
							address: this.getCurrentResource.additional_info.location,
							city: "",
							cx,
							cy,
							activity_name: found.label,
						};
					}
				}
			}
			return defaultPoint;
		},
		manageOptimizationAlert(status = "OK") {
			let text = "",
				title = "",
				active = true;
			switch (status) {
				case "OK":
					this.optimizeAlert2 = true;
					break;
				case "ERROR":
					title = `${this.$t("ErrorTitle")} ${this.$t("Status")}: 200`;
					(text = `${this.$t("Routing.ErrorOptimization")}`),
						Object.assign(this.optimizeAlert, {
							active,
							title,
							text,
							color: "danger",
						});
					break;
				case "ALERT":
					title = this.$t("Roles.Permissions.RequiredConfig");
					if (!this.servirouteCreatePermission) {
						text = `${this.$t("Roles.Permissions.RequiredPermissionsText")} SERVIROUTES_${this.$t(
							"Crud.Create"
						).toUpperCase()}. ${this.$t("Roles.Permissions.NotPermissionsText")}`;
					}

					if (!this.checkServirouteConfig) {
						text = `SERVIROUTES, ${this.$t("Roles.Permissions.RequiredConfigText")}`;
					}
					Object.assign(this.optimizeAlert, {
						active,
						title,
						text,
						color: "warning",
					});
					break;
				default:
					break;
			}
		},
		/**
		 * ! Esta funcion es pasada como propiedad e invocada desde el componente form-geo
		 * TODO: Recuperar y guardar los valores obtenidos de la georreferenciacion
		 * @param { String } address
		 * @param { String } city
		 * @param { Number } cx float number Eg -73.87575657
		 * @param { Number } cy float number Eg  3.8735575657
		 */
		setDataGeo({address, city, cx, cy, activity_name}) {
			this.formatData = {
				address,
				city,
				cy,
				cx,
				activity_name: activity_name || this.formatData.activity_name,
				visit_point_name: "",
				point: "",
				id: 0,
			};
		},
		addPoint() {
			if (this.locationPoints.length < 2 && this.formatData.cx) {
				this.formatData.id = new Date().getTime();
				this.formatData.event_status_id = 0;
				this.formatData.point = this.typePoint;
				if (!this.formatData.activity_name) {
					if (this.formatData.point === "start") {
						this.formatData.activity_name = this.$t("Routing.DeparturePoint");
					} else {
						this.formatData.activity_name = this.$t("Routing.FinalPoint");
					}
				}
				this.locationPoints.push(this.formatData);
				if (this.formatData.point === "start") {
					this.$store.commit("moduleSchedule/ADD_EVENT_TO_BEGIN", this.formatData);
				} else {
					this.$store.commit("moduleSchedule/ADD_EVENT", this.formatData);
				}
				this.addMarker(this.formatData.cy, this.formatData.cx, this.formatData);
				this.selectedOrigin = null;
				if (this.formatData.point === "start") {
					this.typePoint = "final";
				}
				if (this.formatData.point === "final") {
					this.typePoint = "start";
				}
			}
			this.clearData();
		},
		openConfirmOptimize() {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: this.optimizeRouteTittle,
				text: this.$t("Routing.NoFoundDefaultPoint"),
				accept: this.acceptAlertConfirm,
				acceptText: this.btnAddPointTitle,
				cancelText: this.$t("Cancel"),
			});
		},
		acceptAlertConfirm() {
			this.activePopup = true;
		},
		/**
		 * TODO: Optimizar ruta con servicios de ruteador
		 */
		optimizeRoute() {
			this.optimizeWaypoints = true;
			this.markerArray = [];
			this.positionArray = [];
			removeRoute();
			clearMap();
			// agregamos markers
			this.dataEvents.forEach((element, index) => {
				this.addMarker(element.cy, element.cx, {...element, index: index + 1});
			});
			// Zoom sobre los markers
			fitBoundsMarkerGroup(this.markerArray);
			const initPoint = this.locationPoints.find((lp) => lp.point === "start");
			const endPoint = this.locationPoints.find((lp) => lp.point === "final");
			const payload = {
				resource_id: this.currentResourceId,
				date_prog: DateUtils.toDefaultDateTime(this.currentDay, "YYYY-MM-DD"),
				init_cx: initPoint.cx,
				init_cy: initPoint.cy,
				init_hour: this.initHour || "08:00:00",
			};
			if (endPoint) {
				payload["end_cx"] = endPoint.cx;
				payload["end_cy"] = endPoint.cy;
			}
			this.showMagicWand = true;
			this.$store
				.dispatch("moduleSchedule/eventRoute", payload)
				.then((res) => {
					clearMap();
					const data = res.data;
					if (data && data.length > 0) {
						this.optimizeRouteWithHereRoute();
						this.optimizationStatus = true;
						this.$vs.notify({
							color: "success",
							title: this.$t("Routing.Optimization"),
							text: this.$t("Routing.SuccessOptimization.TextOne"),
							time: 6000,
						});
						const eventsRouted = data.filter((event) => event.date_prog !== this.currentDate);
						if (eventsRouted.length > 0) {
							this.$vs.notify({
								color: "warning",
								title: this.$t("Routing.Optimization"),
								text: this.$t("Routing.OverlapEventsWarning"),
								fixed: true,
							});
						}

						this.manageOptimizationAlert("OK");
					} else {
						this.manageOptimizationAlert("ERROR");
					}
					setTimeout(() => {
						this.showMagicWand = false;
					}, 4000);
				})
				.catch((err) => {
					this.showMagicWand = false;
					let text = this.$t("Routing.ErrorOptimization");
					if (
						Object.hasOwnProperty.call(err.data, "reason") &&
						err.data.reason === "The date_prog must be greater than current date"
					) {
						text = this.$t("Routing.DateLessThanCurrentDate");
					}
					this.$vs.notify({
						color: "danger",
						title: this.$t("ErrorTitle"),
						text,
						time: 5000,
					});
				});
		},
		getCurrentDay() {
			return this.currentDay;
		},
		async callbackClick(markerEvent) {
			this.popupMapMounted = false;
			if (this.selectedOrigin) {
				const user = await this.userSession.getUser();
				this.$store
					.dispatch("moduleCompany/getCompanyId", user.company_id)
					.then((res) => {
						this.geoInverso({
							country: res.data[0]["country"],
							cy: markerEvent.lat,
							cx: markerEvent.lng,
						});
					})
					.catch((error) => console.error(error));
			}
		},
		selectTool(opc) {
			if (!this.selectToolSelected) {
				selectTool(opc, this);
				this.selectToolSelected = true;
			} else {
				selectTool(null, null);
				this.selectToolSelected = false;
			}
		},
		cancel() {
			this.clearData();
		},
		close() {
			this.clearData();
		},
		handleAssigned() {
			this.formatData.cx = this.getCurrentVisitPoint.cx;
			this.formatData.cy = this.getCurrentVisitPoint.cy;
			this.formatData.activity_name = this.getCurrentVisitPoint.name;
			this.formatData.address = this.getCurrentVisitPoint.address;
			this.visitPointMounted = false;
		},
		handleHover({name, color, description}) {
			this.activeAlert = true;
			this.originPoint = name;
			this.originColor = color;
			this.vsAlertText = description;
		},
		selectOrigin(val) {
			this.selectedOrigin = val;
			this.activePopup = false;
			switch (val) {
				case "map":
					this.popupMapMounted = true;
					break;
				case "visitpoint":
					this.activePrompt = true;
					break;
				case "geo":
					this.activePrompt = true;
					break;
				default:
					break;
			}
		},
		geoInverso({country, cy, cx}) {
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {country, cy, cx})
				.then((res) => {
					this.closeLoading();
					if (res.data.status === "C") {
						Object.assign(this.formatData, {
							cy,
							cx,
							address: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
						});
					}

					if (res.data.address1) {
						this.formatData = {
							address: res.data.address1,
							city: res.data.city1,
							cx,
							cy,
							activity_name: "",
							visit_point_name: "",
							point: "",
							id: 0,
						};
					}
					this.activePrompt = true;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		deletePoint(row) {
			const foundIndex = this.locationPoints.findIndex((e) => e.point === row.point);
			if (foundIndex >= 0) {
				this.locationPoints.splice(foundIndex, 1);
				this.deleteMarker(row);
				this.$store.commit("moduleSchedule/REMOVE_POINT", row);
			}
		},
		/**
		 * TODO: Animar un marker aplicando la animación BOUNCE,
		 * @param {markerFound} markerFound - Elemento marker en el array de markers
		 */
		animateMarker(markerFound) {
			centerHereMap(markerFound.getGeometry().lat, markerFound.getGeometry().lng, {zoom: 13});
		},
		handleSelected(row) {
			const markerFound = this.markerArray.find((m) => m.info.id === row.id);
			if (markerFound) {
				this.animateMarker(markerFound);
			}
		},
		deleteMarker(row) {
			const markerFound = this.markerArray.find((m) => m.info.id === row.id);
			if (markerFound) {
				removeMarker(markerFound);
			}
		},
		/**
		 * ! Esta funcion es pasada como propiedad e invocada desde el componente form-geo
		 * TODO: Mostrar la alerta acorde a la respuesta del georrefenciador
		 */
		showDataGeoAlert(text, color) {
			this.geoAlert = true;
			this.geoAlertColor = color;
			this.geoAlertText = text;
			if (color === "danger") {
				this.formatData.cy = 0;
				this.formatData.cx = 0;
			}
		},
		/**
		 * TODO: Reordenar los eventos en la lista teniedo en cuenta el orden devuelto por direction
		 * @param {Array} directionWaypointsOrder array de posiciones reordenadas devuelto por Here Maps Directions API
		 * en este caso los waypoints que se le envian al servicio sin tener en cuenta el origen y el fin
		 * ! Este metodo se ejecuta cuando la respuesta de directions cambia el valor del directionResponse en el watch
		 */
		reorderEvents(directionWaypointsOrder = []) {
			const eventSlice = this.dataEvents.slice(1, this.dataEvents.length - 1);
			const order = directionWaypointsOrder;
			const newOrder = order.map((e, i, d) => eventSlice[e]);
			newOrder.unshift(this.dataEvents[0]);
			newOrder.push(this.dataEvents[this.dataEvents.length - 1]);
			this.$store.commit("moduleSchedule/SET_SCHEDULE_EVENTS_BY_PARTS", newOrder);
		},
		/**
		 * TODO: Reagendar todos los eventos del calendario acpetando las fechas propuestas por la optimizacion
		 */
		acceptOptimization() {
			this.openLoading();
			this.$store
				.dispatch("moduleSchedule/editEvent", this.dataEvents)
				.then((res) => {
					this.closeLoading();
					if (res.error.length > 0) {
						const eventErrors = res.error || [];
						this.$vs.notify({
							color: "danger",
							title: this.$t("Schedule.ErrorProcess.Title"),
							text: `${eventErrors.length} ${this.$t("Schedule.ReassignTextError")}`,
							time: 6000,
						});
					} else {
						this.$vs.notify({
							color: "success",
							title: this.$t("Routing.RescheduledEvents"),
							text: this.$t("Routing.RescheduledEventsText"),
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.showErrorAlert();
				});
		},
		showErrorAlert() {
			this.$vs.notify({
				color: "danger",
				title: this.$t("Schedule.ErrorProcess.Title"),
				text: this.$t("Schedule.ErrorProcess.Text"),
			});
		},
	},
	watch: {
		currentDay() {
			this.markerArray = [];
			this.locationPoints = [];
			this.typePoint = "start";
			clearMap();
			this.getEvents();
		},
		showRouteMap(val) {
			this.$store.commit("moduleSchedule/TOGGLE_MAP", val);
		},
		/**
		 * ! Este valor se modifica desde el metodo  calculateHereRoute. siempre y cuando
		 * ! se invoque a traves del metodo  call() devolviendo un array de enteros
		 */
		directionResponse(val) {
			if (val.waypoint_order.length > 0) {
				this.reorderEvents(val.waypoint_order);
			}
		},
		popupMapMounted(val) {
			if (val && this.dataEvents.length > 0) {
				this.mapConfig.latitude = +this.dataEvents[0].cy;
				this.mapConfig.longitude = +this.dataEvents[0].cx;
			}
		},
	},
	created() {
		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
		this.getEvents();
	},
};
</script>

<style lang="scss">
.scroll-area {
	position: relative;
	margin: auto;
	width: 100%;
	height: 500px;
}
</style>
